import { Instagram, Linkedin, Mail } from "lucide-react";

const NAV = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Founders", id: "philosophy" },
  { label: "Partners", id: "partners" },
  { label: "Apply", id: "apply" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-black text-white border-t border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 pt-24 md:pt-32 pb-10">
        <div className="grid grid-cols-12 gap-y-16 md:gap-x-16">
          <div className="col-span-12 md:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-8">
              §07 — Contact
            </p>
            <h3 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight max-w-[14ch]">
              Begin a <span className="italic font-light">conversation.</span>
            </h3>
            <a
              data-testid="footer-email"
              href="mailto:hello@runwayfoundry.com"
              className="mt-10 inline-block font-serif text-2xl md:text-3xl link-underline"
            >
              hello@runwayfoundry.com
            </a>
            <div className="mt-12 space-y-3 text-sm text-white/55 font-light">
              <p>Founder inquiries — apply via the application form.</p>
              <p>Press & partnerships — hello@runwayfoundry.com</p>
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-8">Index</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    data-testid={`footer-nav-${n.id}`}
                    onClick={() => scrollTo(n.id)}
                    className="link-underline text-sm text-white/70 hover:text-white"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-8">Channels</p>
            <ul className="space-y-4">
              <li>
                <a
                  data-testid="footer-instagram"
                  href="https://instagram.com/runwayfoundry"
                  target="_blank"
                  rel="noreferrer"
                  className="group inline-flex items-center gap-3 text-sm text-white/70 hover:text-white"
                >
                  <Instagram size={16} />
                  <span className="link-underline">Instagram — @runwayfoundry</span>
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-linkedin"
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noreferrer"
                  className="group inline-flex items-center gap-3 text-sm text-white/70 hover:text-white"
                >
                  <Linkedin size={16} />
                  <span className="link-underline">LinkedIn — Runway Foundry</span>
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email-link"
                  href="mailto:hello@runwayfoundry.com"
                  className="group inline-flex items-center gap-3 text-sm text-white/70 hover:text-white"
                >
                  <Mail size={16} />
                  <span className="link-underline">hello@runwayfoundry.com</span>
                </a>
              </li>
            </ul>

            <div className="mt-12">
              <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">Founder Direct</p>
              <p className="text-sm text-white/70">founders@runwayfoundry.com</p>
            </div>
          </div>
        </div>

        {/* Massive wordmark */}
        <div className="mt-24 md:mt-32 border-t border-white/10 pt-12">
          <h2 className="font-serif text-white text-[18vw] md:text-[14vw] lg:text-[12vw] leading-[0.85] tracking-tighter select-none">
            Runway <span className="italic font-light">Foundry</span>
          </h2>
        </div>

        <div className="mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] uppercase tracking-[0.3em] text-white/40">
          <span>© {new Date().getFullYear()} Runway Foundry — All Rights Reserved</span>
          <span>The Future Infrastructure of Fashion</span>
          <span>MMXXV</span>
        </div>
      </div>
    </footer>
  );
}
